import { ApolloLink } from "apollo-link";
import {
  deprecatedGraphQLOperationsIndex,
  deprecatedGraphQLFragmentsIndex,
} from "./deprecations";

export default () =>
  process.env.NODE_ENV === "production"
    ? null
    : new ApolloLink((operation, forward) => {
        const operationName = operation.getContext();
        if (deprecatedGraphQLOperationsIndex[operationName]) {
          console.warn(deprecatedGraphQLOperationsIndex[operationName]);
        } else {
          const deprecatedFragments = operation.query.definitions
            .filter(
              ({ kind, name }) =>
                kind === "FragmentDefinition" &&
                deprecatedGraphQLFragmentsIndex[name?.value]
            )
            .map(({ name }) => deprecatedGraphQLFragmentsIndex[name.value]);

          deprecatedFragments.forEach((fragmentName) =>
            console.warn(deprecatedGraphQLFragmentsIndex[fragmentName])
          );
        }
        return forward(operation);
      });
